<template>
    <div class="box subscribe-links">
        <h2 class="box-title">
            Subscribe Links
        </h2>
        <div class="box-content">
            <p class="description">
                Enter the unique Subscriber Link URL you received from each podcast directory on which your show has been approved. This will allow listeners to find your podcast on their favorite platform right within the Fusebox player.
            </p>
            <form
                id="subscribe-links"
                novalidate
                @submit.prevent="saveInfo"
            >
                <div
                    v-for="(linkField, key) in config"
                    :key="linkField.label"
                    class="field flex"
                >
                    <span class="field-title">
                        <svg-vue
                            :class="[`link-icon-${iconName(linkField.label)}` , 'link-icon']"
                            :icon="`icon-${iconName(linkField.label)}`"
                        />
                        {{ linkField.label }}:
                    </span>
                    <div class="input">
                        <fieldset>
                            <input
                                :id="key"
                                v-model="config[key].url"
                                type="text"
                                :name="key"
                                autocomplete="off"
                                @blur="embedSettingsChange"
                            >
                        </fieldset>
                    </div>
                </div>
                <div class="controll-container flex">
                    <base-form-button
                        class="btn"
                        :loading="formProcessing"
                    >
                        Save Changes
                    </base-form-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {
    isEqual,
    kebabCase,
} from 'lodash';
import prefixUrlInput from '@/utils/form/prefixUrlInput';

export default {
    props: {
        show: {
            type: Object,
            default: () => ({}),
        },

        formProcessing: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        config: {
            rss: {
                label: 'RSS',
                url: '',
            },
            apple: {
                label: 'Apple Podcast',
                url: '',
            },
            google: {
                label: 'Google Podcast',
                url: '',
            },
            stitcher: {
                label: 'Stitcher',
                url: '',
            },
            spotify: {
                label: 'Spotify',
                url: '',
            },
            tunein: {
                label: 'TuneIn',
                url: '',
            },
            overcast: {
                label: 'Overcast',
                url: '',
            },
        },
    }),

    watch: {
        show: {
            immediate: true,

            /**
             * Manage data.
             *
             * @param {object}  show        Show object data.
             * @param {*}       oldShow     Show object data null.
             */
            handler(show, oldShow) {
                if (isEqual(show.buttonConfig.subscribe, oldShow?.buttonConfig?.subscribe)) {
                    return;
                }

                this.config = show.buttonConfig.subscribe;
            },
        },
    },

    methods: {
        /**
         * Submit form
         *
         */
        saveInfo() {
            this.$emit('submit', {
                buttonConfig: {
                    ...this.show.buttonConfig,
                    subscribe: {
                        ...this.config,
                    },
                },
            });
        },

        /**
         * Submit embed change
         *
         */
        embedSettingsChange() {
            for (const service in this.config) {
                const { url } = this.config[service];

                if (url) {
                    this.config[service].url = prefixUrlInput(url);
                }
            }
        },

        /**
         * Return formated icon name
         *
         * @param {string} string Field Label
         * @returns  {string}  Formated field icon name
         */
        iconName(string) {
            return kebabCase(string);
        },
    },
};
</script>
